module.exports = __webpack_public_path__ + "img/royal hospitals indoor shoot-264.f08f7b5b.webp";